/** /change-password: the new password for a reset link from the e-mail. */

import { confirmPasswordReset } from "./api/client";
import { minimumLength, passwordProblem } from "./account";
import { find, setMessage } from "./lib/dom";
import { formValue, isBusy, setBusy } from "./lib/forms";
import { ApiError, errorMessage } from "./lib/http";

const REDIRECT_DELAY_MS = 3_000;
const PAGE_PATH = "/change-password";

export function initReset(): void {
  // the token stays in the form: keep it out of the address bar and the history
  if (window.location.search !== "") {
    window.history.replaceState(null, "", PAGE_PATH);
  }
  const form = find(document, "[data-reset-form]", HTMLFormElement);
  if (form === null) return;
  const error = find(form, "[data-form-error]", HTMLElement);
  const success = find(form, "[data-form-success]", HTMLElement);
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    if (isBusy(form)) return;
    const token = formValue(form, "token");
    const password = formValue(form, "new_password");
    const problem = passwordProblem(
      password,
      formValue(form, "new_password_confirm"),
      minimumLength(form),
    );
    if (error) setMessage(error, problem);
    if (problem !== "") return;
    setBusy(form, true);
    confirmPasswordReset(token, password).then(
      () => {
        if (success) success.hidden = false;
        window.setTimeout(() => {
          window.location.assign("/");
        }, REDIRECT_DELAY_MS);
      },
      (failure: unknown) => {
        setBusy(form, false);
        const message =
          failure instanceof ApiError && failure.code === "invalid_token"
            ? "This link is invalid or has expired. Please request a new one."
            : errorMessage(failure);
        if (error) setMessage(error, message);
      },
    );
  });
}
